window._ = require('lodash');

// https://dockyard.com/blog/2020/02/14/you-probably-don-t-need-moment-js-anymore
// replace moment when possible
//window.moment = require('moment-timezone');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

/*window.Pusher.logToConsole = true;*/

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

document.addEventListener('DOMContentLoaded', () => {
    (document.querySelectorAll('.notification .delete') || []).forEach(($delete) => {
        const $notification = $delete.parentNode;

        $delete.addEventListener('click', () => {
            $notification.parentNode.removeChild($notification);
        });
    });
});


document.addEventListener('DOMContentLoaded', () => {

    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

        // Add a click event on each of them
        $navbarBurgers.forEach( el => {
            el.addEventListener('click', () => {

                // Get the target from the "data-target" attribute
                const target = el.dataset.target;
                const $target = document.getElementById(target);

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                el.classList.toggle('is-active');
                $target.classList.toggle('is-active');

            });
        });
    }

    // Get all "navbar-burger" elements
    const $navBurgers = Array.prototype.slice.call(document.querySelectorAll('.tailwind-burger'), 0);

    // Check if there are any navbar burgers
    if ($navBurgers.length > 0) {

        // Add a click event on each of them
        $navBurgers.forEach(el => {
            el.addEventListener('click', () => {


                const open = el.querySelector('.block');
                const hidden = el.querySelector('.hidden');

                open.classList.add('hidden');
                open.classList.remove('block');


                hidden.classList.remove('hidden');
                hidden.classList.add('block');

                // Get the target from the "data-target" attribute

                const $target = document.getElementById(el.dataset.target);

                $target.classList.toggle('hidden');
                $target.classList.toggle('block');


                // This returns a HTMLCollection (a type of array), so we have to iterate to access every child's content.

                /*open.forEach(function (e) {
                    e.classList.add('hidden');
                    e.classList.remove('block');
                });*/


                /* const hidden = el.querySelectorAll('.hidden');

                 hidden.forEach(function (e) {
                     e.classList.add('block');
                     e.classList.remove('hidden');
                 });*/

            });
        });
    }

    // Get all "navbar-burger" elements
    const $clickToggles = Array.prototype.slice.call(document.querySelectorAll('.toggle-click-hidden'), 0);

    // Check if there are any navbar burgers
    if ($clickToggles.length > 0) {

        // Add a click event on each of them
        $clickToggles.forEach(el => {
            el.addEventListener('click', () => {

                // Get the target from the "data-target" attribute
                const target = el.dataset.target;
                const $target = document.getElementById(target);

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                //el.classList.toggle('is-active');
                $target.classList.toggle('hidden');

            });
        });
    }

    const passwordToggle = document.querySelector('.js-password-toggle');

    if (passwordToggle) {
        passwordToggle.addEventListener('change', function () {
            const password = document.querySelector('.js-password'),
                passwordLabel = document.querySelector('.js-password-label');

            if (password.type === 'password') {
                password.type = 'text';
                passwordLabel.innerHTML = 'hide';
            } else {
                password.type = 'password'
                passwordLabel.innerHTML = 'show';
            }

            password.focus();
        })
    }

});

//window.videojs = require('video.js');


/*
const fileInputter = document.querySelector('#file-js-example input[type=file]');
console.log(fileInputter);
fileInputter.onchange = () => {
    console.log('change');
    if (fileInputter.files.length > 0) {
        const fileName = document.querySelector('#file-js-example .file-name');
        fileName.textContent = fileInputter.files[0].name;
    }
}
*/

